import React from "react";
import { Alert, Text, TextLink } from "@origin-digital/ods-core";
import { AlertTones } from "@origin-digital/ods-types/.";

export enum InternetRequestStatusEnum {
  CAN_RETAIL = "CAN_RETAIL",
  NOT_AVAILABLE = "NOT_AVAILABLE",
  PRE_INSTALL_REQD_NBN = "PRE_INSTALL_REQD_NBN",
  PRE_INSTALL_REQD_OPTICOMM = "PRE_INSTALL_REQD_OPTICOMM",
  NOT_FOUND = "NOT_FOUND",
}

const INTERNET_CONN_STATUS_ALERTS: Partial<
  Record<
    InternetRequestStatusEnum,
    { message: React.ReactNode; tone: AlertTones; title: string }
  >
> = {
  [InternetRequestStatusEnum.NOT_AVAILABLE]: {
    message: (
      <Text>
        Sorry, we're unable to offer a internet connection at this address.
      </Text>
    ),
    tone: "caution",
    title: "Internet connection not available",
  },
  [InternetRequestStatusEnum.PRE_INSTALL_REQD_NBN]: {
    message: (
      <Text>
        Please{" "}
        <TextLink
          href="https://www.nbnco.com.au/develop-or-plan-with-the-nbn/new-developments/pre-installation-request/new"
          target="_blank"
        >
          request pre-installation with NBN
        </TextLink>{" "}
        for this address.
      </Text>
    ),
    tone: "info",
    title:
      "You can't use this form to request an internet connection right now",
  },
  [InternetRequestStatusEnum.PRE_INSTALL_REQD_OPTICOMM]: {
    message: (
      <Text>
        Please{" "}
        <TextLink href="#">request pre-installation with Opticomm</TextLink> for
        this address.
      </Text>
    ),
    tone: "info",
    title:
      "You can't use this form to request an internet connection right now",
  },
  [InternetRequestStatusEnum.NOT_FOUND]: {
    message: (
      <Text>
        You will not be able to request internet at this time and you will need
        to try again later as we cant offer a retail plan for the address at
        this time.
      </Text>
    ),
    tone: "caution",
    title: "We couldn't find your address for a internet connection",
  },
};

const ServiceTypeStatusAlert: React.FC<{
  status: InternetRequestStatusEnum | null;
}> = ({ status }) => {
  const config =
    INTERNET_CONN_STATUS_ALERTS[status as InternetRequestStatusEnum];

  if (!config) return null;
  return (
    <Alert title={config.title} tone={config.tone}>
      {config.message}
    </Alert>
  );
};

export default ServiceTypeStatusAlert;
